<template>
    <div class="login">
        <div class="title">紫东线上生活超市平台</div>
        <el-card style="font-size: 30px;" header="登录" class="box-card">
            <el-form :model="loginData" :rules="formRules" size="medium" label-width="80px" style="margin:0 10px">
                <el-form-item label="账号" prop="mobile">
                    <el-input v-model="loginData.mobile" placeholder="请输入账号" prefix-icon='el-icon-phone'
                        :style="{ width: '100%' }"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="loginData.password" placeholder="请输入密码" prefix-icon='el-icon-user-solid'
                        :style="{ width: '100%' }" show-password></el-input>
                </el-form-item>
                <!-- <el-button @click="cancelLogin()">取消</el-button> -->
              <div>
                <el-button @click="confirmLogin()">确认</el-button>
              </div>
            </el-form>
        </el-card>
    </div>


</template>

<script>
// import STORE from '@/store'

export default {
    inject: ["reloadTopNav"], // 注入“重新加载导航栏”方法
    components: {},
    props: {},
    data() {
        return {


            loginData: {
                mobile: '',
                password: '',
            },
            formRules: {
                mobile: [{
                    required: true,
                    message: '请输入账号',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }],
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        confirmLogin() {
            this.$store
                    .dispatch("User/login", this.loginData)
                    .then(() => {
                        this.$message({
                            message: '登录成功',
                            type: 'success'
                        });
                        this.reloadTopNav();
                        this.$router.replace('/Data');
                        document.onkeydown = undefined;
                        // resolve(res);
                      this.$store.commit('refreshVisitorMode');
                    })
                    .catch((error) => {
                        this.$message({
                            message: '登录失败',
                            type: 'error'
                        });
                        console.log(error);
                    });

        }
    },
    created() {
        var key;
        var _self = this;
        document.onkeydown = function(e){
        if(window.event == undefined){
            key = e.key;
        }else{
            key = window.event.keyCode;
        }
        if(key == 13){
            _self.confirmLogin();
        }
    }
    },
    mounted() { }
};
</script>
<style scoped>

.title {
    margin: 30px auto;
    font-size: 64px;
}

.box-card {
    width: 480px;
    margin: 10% auto;
    border-radius: 25px;
    opacity: 0.8;
}

el-input {
    border-radius: 25px;
}

el-button {
    border-radius: 25px;
}
</style>
